
/*
    Requests for getting user related information,
    logging in, access details, or CRUD operations for user records
*/

import axios from "axios";
import BaseValues, { setSSOToken } from "./BaseValues";
import Constants from "../Constants";

//
// get the role of the given user
//
export const getUserRole = (username) => {

    console.log("USER ROLE", username);

    const data = BaseValues.createFormData({userid: username});
    
    const url = `${BaseValues.BaseURL}/api/User/getRoles`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// not an API request, just takes in the role name and spits out the access object
//
export const getAccessDetails = (role) => {

    console.log("role", role);

    const lowerRole = role.toLowerCase();

    switch(lowerRole){
        case "administrator":
            return Constants.access.admin;
        case "supervisor":
            return Constants.access.supervisor;
        case "starter":
            return Constants.access.starter;
        case "report":
            return Constants.access.report;
        case "operator":
            return Constants.access.operator;
        default:
            return null;
    }
}

//
// log the user in to get a token to use with the API
//
export const login = (userdata) => {

    const data = BaseValues.createFormData({
        username: userdata.username,
        password: userdata.password,
        app: "BusConsoleAPI"
    });

    const url = `${BaseValues.BaseURL}/api/User/authenticateUser`;

    console.log("login url", url);

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

// how to make it so that we don't keep trying to check for this everytime...
// only do it on the login page load?
export const SSO_Login = (accept, reject) => {
    // eslint-disable-next-line no-undef
    if(window.SSO_signIn){
        window.SSO_signIn(accept, reject);
    }
}

//
// get user information after successful login
//
export const getUserDetails = (username) => {

    console.log("GET USER DETAILS", username);

    const data = BaseValues.createFormData({
        userid: username 
    }, false, "getUserDetails; " + BaseValues.BaseURL);

    const url = `${BaseValues.BaseURL}/api/User/getUserDetails`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// get a list of users which match the given input values
//
export const getUsers = (user) => {

    console.log("GET USERS", user);

    const data = BaseValues.createFormData({
        username: user.username,
        first_name: user.first_name,
        last_name: user.last_name    
    });

    const url = `${BaseValues.BaseURL}/api/User/getUsers`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// create a new PCS user record
//
export const addUser = (user) => {
    const data = BaseValues.createFormData({
        username: user.username,
        first_name: user.first_name,
        middle_initial: user.middle_initial,
        last_name: user.last_name,
        status: "ENABLED",
        role: user.role,
        groupid: user.groupid,
        location: user.location
    });

    const url = `${BaseValues.BaseURL}/api/User/addUser`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// update a PCS user record
//
export const updateUser = (user) => {

    console.log("UPDATE USER", user);

    const data = BaseValues.createFormData({
        username: user.username,
        first_name: user.first_name,
        middle_initial: user.middle_initial,
        last_name: user.last_name,
        role: user.role,
        groupid: user.groupid,
        status: user.enabled ? "ENABLED" : "DISABLED",
        locationid: user.location
    });

    const url = `${BaseValues.BaseURL}/api/User/updateUser`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// delete a PCS user record 
// (I believe on the DB side this just marks as disabled and doesn't return for queries)
//
export const deleteUser = (username) => {
    console.log("DELETE USER", username);

    const data = BaseValues.createFormData({
        username
    });

    const url = `${BaseValues.BaseURL}/api/User/deleteUser`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}